import SequencesQueue from './SequenceQueue';

class SequenceStack {
  private stack: Array<SequencesQueue>;
  constructor(stack: Array<SequencesQueue>) {
    this.stack = stack;
  }

  static init() {
    return new SequenceStack([]);
  }

  pop(): SequencesQueue | undefined {
    return this.stack.pop();
  }

  push(sequencesQueue: SequencesQueue): void {
    this.stack.push(sequencesQueue);
  }

  peek(): SequencesQueue {
    return this.stack[this.size - 1];
  }

  clear(): void {
    this.stack = [];
  }

  get size(): number {
    return this.stack.length;
  }

  json() {
    return JSON.stringify(this.stack.map((sequences: SequencesQueue) => sequences.json()));
  }

  static fromJson(jsonString: string) {
    const stack = JSON.parse(jsonString);
    return new SequenceStack(stack.map((sq: string) => SequencesQueue.init(sq)));
  }
}

export default SequenceStack;
